import { NavLink as MantineNavLink } from '@mantine/core';
import { useHover } from '@mantine/hooks';
import type { ReactNode } from 'react';

interface NavLinkProps {
	href: string;
	label: string;
	icon?: ReactNode;
	children?: ReactNode;
	defaultOpened?: boolean;
}

export function NavLink({
	href,
	label,
	children,
	icon,
	defaultOpened,
}: NavLinkProps) {
	const { hovered, ref } = useHover();

	const navLinkProps = {
		href,
		label,
		ref,
		c: 'white',
		fw: 500,
		bg: hovered ? 'medepos.1' : 'medepos.0',
		childrenOffset: 28,
		leftSection: icon,
		defaultOpened,
	};

	return (
		<>
			{children == null ? (
				<MantineNavLink {...navLinkProps} />
			) : (
				<MantineNavLink {...navLinkProps}>{children}</MantineNavLink>
			)}
		</>
	);
}
